import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

export default class MwButtonBuilder extends Component {
  @tracked size = 'm';
  @tracked variant = 'primary';
  @tracked label = 'Button text';
  @tracked disabled = false;
  @tracked inProgress = false;
  @tracked transparent = false;
  @tracked icon = '';
  @tracked iconSize = '24';
  @tracked type = 'button';
  sizeOptions = ["s","m","l","xl (circle only)"];
  variantOptions = ["primary","secondary","tertiary","circle"];
  iconSizeOptions = ["12","16","24","32"];
  typeOptions = ["button","submit"];

  @action
  setSize(value) {
    this['size'] = value;
  }

  @action
  setVariant(value) {
    this['variant'] = value;
  }

  @action
  setLabel(event) {
    this['label'] = event.target.value;
  }

  @action
  setDisabled(value) {
    this['disabled'] = value;
  }

  @action
  setInProgress(value) {
    this['inProgress'] = value;
  }

  @action
  setTransparent(value) {
    this['transparent'] = value;
  }

  @action
  setIcon(event) {
    this['icon'] = event.target.value;
  }

  @action
  setIconSize(value) {
    this['iconSize'] = value;
  }

  @action
  setType(value) {
    this['type'] = value;
  }

  @action
  resetToDefaults() {
    this['size'] = 'm';
    this['variant'] = 'primary';
    this['label'] = 'Button text';
    this['disabled'] = false;
    this['inProgress'] = false;
    this['transparent'] = false;
    this['icon'] = '';
    this['iconSize'] = '24';
    this['type'] = 'button';
  }
}
